

export const previousSubject = (subject) => dispatch => {
    dispatch({
        type: 'PREVIOUS_SUBJECT',
        payload: subject
    });
}